import { render, staticRenderFns } from "./TDAdd.vue?vue&type=template&id=a206aeca&"
import script from "./TDAdd.vue?vue&type=script&lang=js&"
export * from "./TDAdd.vue?vue&type=script&lang=js&"
import style0 from "./TDAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports